import React from 'react';

export default function ThingsWeTrade() {
  return (
    <section className="pt-28 pb-32 px-4 text-white bg-[#060b29] min-h-screen">
      <div className="max-w-4xl mx-auto text-center">

        <h1 style={{ marginBottom: '50px' }} className="text-4xl md:text-5xl font-bold text-white">
          Things We Trade
        </h1>

        <div>
          <h2 className="text-purple-300 mb-2" style={{ fontSize: '32px' }}>
            1. Forex
          </h2>
          <p style={{ fontSize: '20px', marginBottom: '40px' }} className="text-gray-300 leading-relaxed">
            The Forex market is the largest and most liquid financial market globally with over <span className="text-white font-semibold">$7 trillion</span> traded daily. PipPlus Tech focuses on major and minor currency pairs with high volatility and tight spreads.<br />
            Major pairs: EUR/USD, GBP/USD<br />
            Minor pairs: AUD/JPY, USD/CHF<br />
            Real-time algorithmic execution
          </p>
        </div>

        <div>
          <h2 className="text-purple-300 mb-2" style={{ fontSize: '32px' }}>
            2. Comex
          </h2>
          <p style={{ fontSize: '20px', marginBottom: '40px' }} className="text-gray-300 leading-relaxed">
            Commodities like <span className="text-white font-semibold">Gold (XAUUSD)</span> and <span className="text-white font-semibold">Silver (XAGUSD)</span> are traded through our Comex Smart Trading system, leveraging precision signals based on price action, news, and technical setups.<br />
            Metal-focused automation<br />
            Risk-managed setups<br />
            High reward:risk strategies
          </p>
        </div>

        <div>
          <h2 className="text-purple-300 mb-2" style={{ fontSize: '32px' }}>
            3. Crypto
          </h2>
          <p style={{ fontSize: '20px', marginBottom: '40px' }} className="text-gray-300 leading-relaxed">
            Trade digital assets like <span className="text-white font-semibold">BTC</span>, <span className="text-white font-semibold">ETH</span>, and <span className="text-white font-semibold">USDT</span> with 24/7 execution. Our systems adapt to crypto volatility and use AI to detect high-probability scalping and swing trade setups.<br />
            DeFi and major crypto assets<br />
            Bot-driven alerts for entries<br />
            Smart trade routing
          </p>
        </div>

      </div>
    </section>
  );
}
